import React from "react";

export function SectionTitle({ eyebrow, title, subtitle, align = "left", light = false }) {
  return (
    <div className={`mb-12 ${align === "center" ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}`}>
      {eyebrow && (
        <div className={`eyebrow mb-3 ${light ? "text-[#d4af37]" : "text-[#1e6dd8]"}`}>{eyebrow}</div>
      )}
      <h2 className={`font-serif-hsa text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.1] mb-4 ${light ? "text-white" : "text-[#0a2540]"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`text-base sm:text-lg leading-relaxed ${light ? "text-white/80" : "text-slate-600"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}

export function Section({ children, className = "", id }) {
  return (
    <section id={id} className={`py-20 md:py-28 ${className}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">{children}</div>
    </section>
  );
}
